<template>
  <div class="template-cookiePopup" v-if="!policyAccepted">
    <div class="cookiePopup" v-if="policyPopup">
      <h3 class="text-center">About Cookies On This Site</h3>
      <p class="text-center">We use cookies. When you interact with Canon websites, we'd like to provide you with the best experience that we can. Cookies are used to help personalise your online experience, tailor advertising, and learn how visitors use our website. By clicking on 'I Accept', all cookies will be delivered. You can learn more by clicking 'Cookie Policy'.</p>
      <button class="Btn Accept" type="button" @click="acceptCookies()">Accept</button>
      <button class="Btn" type="button" @click="viewPolicy()">Cookie Policy</button>
    </div>
    <div class="cookiePopup policyPopup" v-if="policyScreen">
      <div class="closeBtn" @click="closePolicyPopup()">
        <p>x</p>
      </div>
      <h3>Cookie policy</h3>
      <h5>What are cookies?</h5>
      <p>Small text files known as cookies will be installed on your computer to distinguish you from other users of our website, to understand what content you are interested in, and to collect statistical information including navigation paths, number of visits, returning customers and hits per page. By continuing to browse the site, you are agreeing to our use of cookies.</p>
      <h4>Our Cookie policy – How Canon ID uses cookies</h4>
      <h5>Necessary cookies</h5>
      <p>To make full use of the content and features on Canon ID, your computer, tablet or mobile phone will need to accept cookies (and often does so by default), as we can only provide you with certain personalised features on this website by using them. Our cookies don't store sensitive information such as your name, address or payment details. However, if you'd prefer to restrict, block or delete cookies from Canon ID, or any other website, you can use your browser to do this. Each browser is different, so check the 'Help' menu of your particular browser (or your mobile phone’s user manual) to change your cookie preferences.</p>
      <h5>Preferences cookies</h5>
      <p>These cookies help us remember some of your settings so we don't need to ask you again. For example, one of these cookies will remember you have been presented with our Cookie policy so that we don't prompt you each time.</p>
      <h5>Statistics cookies</h5>
      <p>Statistic cookies helps our teams to understand how Canon ID performs and how visitors interact with Canon ID by collecting and reporting information anonymously. For this purpose, Canon ID uses Google Analytics. Find out more on <a href="https://www.google.com/policies/privacy/partners/">how Google uses the data</a> when you use Canon ID.</p>
      <h5>Links from Canon ID to third party websites</h5>
      <p>Canon can’t be responsible for the cookies used on any third party website that is linked or referenced from Canon ID.</p>
      <h5>Third-party cookies</h5>
      <p>When you visit a page on Canon ID which contains embedded content, you may be sent cookies from these websites. We don't control the setting of these cookies, so we suggest you check the third-party websites for more information about their cookies and how to manage them.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CookiePopup",
  data: () => ({
    policyAccepted: false,
    policyPopup: true,
    policyScreen: false,
  }),
  created() {
    if(localStorage.cookiePolicy){
      this.policyAccepted = true
      this.policyPopup = false
    }
  },
  methods: {
    acceptCookies(){
      localStorage.cookiePolicy = 'Accepted';
      this.policyAccepted = true
    },
    viewPolicy(){
      this.policyPopup = false
      this.policyScreen = true
    },
    closePolicyPopup(){
      this.policyPopup = true
      this.policyScreen = false
    }
  }
};
</script>

<style lang="scss" scoped>
.template-cookiePopup{
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.4);
  z-index: 9999;

  .cookiePopup{
    position: fixed;
    width: calc(70vw - 160px);
    height: fit-content;
    max-height: 40vh;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    background-color: $color3;
    padding: 30px;
    overflow: hidden;
    overflow-y: auto;

    .closeBtn{
      position: absolute;
      top: 15px;
      right: 15px;
      background-color: $color1;
      height: 30px;
      width: 30px;
      border-radius: 50%;
      cursor: pointer;

      p{
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        font-size: 18px;
        height: 16px;
        width: 10px;
        font-weight: 800 !important;
        color: $color3;
      }
    }
    h3{
      margin-top: 0px !important;
      margin-bottom: 15px !important;
      font-size: 1.5rem !important;
    }
    h4{
      font-size: 1.3rem !important;
      margin-bottom: 30px !important;
    }
    h5{
      font-size: 1.2rem !important;
      font-weight: 600 !important;
    }
    p{
      margin-top: 0px !important;
      margin-bottom: 30px !important;
    }
    .Btn{
      width: calc(50% - 15px);
      background-color: $color4;
      border: solid 2px $color4;
      border-radius: 30px;
      padding: 6px 10px 6px 30px;
      font-size: 18px;
      font-weight: 600;
      color: $color5;
    }
    .Btn:hover{
      background-color: $color3;
      border-color: $color4;
      color: $color4;
    }
    .Btn.Accept{
      margin-right: 30px;
      background-color: $color1;
      border: solid 2px $color1;
      color: $color3;
    }
    .Btn.Accept:hover{
      background-color: $color3;
      border: solid 2px $color1;
      color: $color1;
    }
  }
  .cookiePopup.policyPopup{
    max-height: 75vh;

    h3{
      margin-bottom: 30px !important;
    }
  }
}
@media (max-width: 900px){
  .template-cookiePopup{
    .cookiePopup{
      width: 90vw;
      max-height: 80vh;

      .Btn{
        width: 100%;
      }
      .Btn.Accept{
        margin-bottom: 15px;
      }
    }
    .cookiePopup.policyPopup{
      max-height: 80vh;
    }
  }
}
</style>
